import React from 'react';
import {AiOutlinePoweroff} from 'react-icons/ai';
import {IconContext} from 'react-icons'

export default function PowerButton (props){
    return (
        <div className= "power-container">
            <div>Power</div>
            <div className={props.powerBtn ? "power-led-off" : "power-led-on"}></div>
            <div  onClick={props.handlePower} className= "control-buttons">
                 <IconContext.Provider value={{className: "power-icon"}}>
                     <AiOutlinePoweroff />
                 </IconContext.Provider>
            </div>
            <div className="control-buttons" onClick={props.goFull}>
              FULL
            </div>
        </div>
    )
}